export const promoteInstallmentsConfiguration = {
  minimumPrice: 0,
  numberOfInstallments: 3,
  productTypeArray: ['sunglasses'],
}

export const graphPromoteInstallmentsConfiguration = {
  minimumPrice: 0,
  numberOfInstallments: 3,
}
